import React from 'react'
import './Hero.css'
import heart from '../../assets/heart.png'
import hero_image from '../../assets/hero_image.png'
import hero_image_back from '../../assets/hero_image_back.png'
import calories from '../../assets/calories.png'
import { Header } from '../Header/Header'
import {motion} from 'framer-motion'
import NumberCounter from 'number-counter'
export const Hero = () => {
  const transition = {type:"swing",duration:3};
  const mobile = window.innerWidth<=768?true:false;
  return (
    <div className="hero" id='hero'>
      <div className='blur hero-blur'></div>
        <div className="left-h">
            <Header/>
            <div className="the-best-add">
              <motion.div initial={{left:mobile?"165px":"238px"}} whileInView={{left:'8px'}} transition={{...transition,type:'tween'}} ></motion.div>
              <span>the best fitness club in the town</span>
            </div>
            {/* {hero text} */}
            <div className="hero-text">
              <div>
                <span className='stroke-text'>shape </span>
                <span>your</span>
              </div>
              <div>
                <span> ideal body</span>
              </div>
              <div>
                <span>In here we will help you to shape and build your ideal body and live up your life to fullest</span>
              </div>
              </div>
              {/* {figures} */}
              <div className="figures">
                <div>
                  <span>
                    <NumberCounter start={100} end={140} preFix='+' delay='4'/>
                  </span>
                  <span>expert coach</span>
                </div>
                <div>
                  <span>
                    <NumberCounter start={900} end={978} preFix="+" delay='4'/>
                  </span>
                  <span>member joined</span>
                </div>
                <div>
                  <span>
                  <NumberCounter start={40} end={50} preFix="+" delay='4'/>

                  </span>
                  <span>fitnes programs</span>
                </div>
              </div>
              {/* {hero-buttons} */}
              <div className="hero-buttons">
                <button className="btn">Get Started</button>
                <button className="btn">Learn More</button>
              </div>
        </div>
        <div className="right-h">
          <button className="btn"> Join Now</button>
          <motion.div initial={{right:'-1rem'}} whileInView={{right:"4rem"} } transition={transition} className="heart-rate">
            <img src={heart} alt="" />
            <span>Heart Rate</span>
            <span>116 bpm</span>
          </motion.div>
          {/* {hero-images} */}
          <motion.img 
          initial={{right:'18rem'}}
          whileInView={{right:"22rem"}}
          transition={transition}
          src={hero_image_back}  className="hero_image_back" alt="" />
          <img src={hero_image} alt=""  className='hero_image'/>
          {/* {calories-card} */}
          <motion.div  
          initial={{right:"37rem"}}
          whileInView={{right:"28rem"}}
          transition={transition}
          className="calories">
            <img src={calories} alt="" />
            <div>
              <span>Calories Burned</span><span>220 kcal</span>
            </div>
          </motion.div>
        </div>
    </div>
  )
}
